import { t } from '@lingui/core/macro';

export default function heightValidator(height: string | undefined) {
  if (height === '' || height === undefined) {
    return t`Высота не может быть пустой`;
  }
  if (isNaN(Number(height))) {
    return t`Не удалось преобразовать высоту в число`;
  }
  if (+height <= 0) {
    return t`Высота не может быть меньше или равна 0`;
  }
  if (+height >= 10000) {
    return t`Высота не может быть больше или равна 10000`;
  }
  return undefined;
}
